var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"rounded-lg",attrs:{"color":_vm.color.chip,"text-color":_vm.color.text}},[_vm._v(_vm._s(_vm.$tc(_vm.status)))])}
var staticRenderFns = []

export { render, staticRenderFns }